// 홈 페이지 번역
export default {
  hero: {
    welcomeTo: '환영합니다',
    churchName: '성동중앙교회',
    subtitle: '믿음, 소망, 사랑이 함께하는 곳',
    visitUs: '방문하기'
  },
  latestNews: {
    sectionLabel: '최신 소식',
    title: '함께 나누는 이야기',
    readMore: '더 보기',
    viewAll: '전체 소식 보기'
  },
  gallery: {
    sectionLabel: '갤러리',
    title: '믿음의 순간들'
  },
  worship: {
    sectionLabel: '예배 안내',
    title: '예배 시간',
    tableService: '예배',
    tableTime: '시간',
    tableLocation: '장소',
    note: '예배 시간 및 장소는 교회 사정에 따라 변경될 수 있습니다.',
    viewDetail: '자세히 보기'
  }
};
